<template>
  <div class="landing">
    <div class="landing-inner">
      <!-- 顶部品牌：与首页同口径，用图标库里的品牌 LOGO 字形占位，不依赖位图资源 -->
      <div class="brand">
        <i class="ca ca-logo brand-logo"></i>
        <div class="brand-name">{{ cfg.appName }}</div>
        <div class="brand-slogan">{{ cfg.slogan }}</div>
      </div>

      <!-- 邀请提示 -->
      <div class="invite-tip" v-if="shareCode">
        来自好友邀请 · 邀请码 <b>{{ shareCode }}</b>
      </div>

      <!-- 微信内打开引导 -->
      <div class="wx-tip" v-if="isWeixin">
        请点击右上角「···」，选择「在浏览器打开」后再进行下载
      </div>

      <!-- 第一步：手机号一键登录/注册 -->
      <div class="card" v-if="!registered">
        <div class="card-title">手机号一键登录 / 注册</div>
        <el-input class="phone-input" v-model="mobile" type="tel" maxlength="11"
          prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号" @keyup.enter.native="submit"></el-input>
        <el-button class="submit-btn" type="primary" :loading="submitting" @click="submit">
          {{ submitting ? '处理中...' : '登录 / 注册' }}
        </el-button>
        <div class="agreement">
          <el-checkbox v-model="agreed"></el-checkbox>
          <span class="agreement-text">
            我已阅读并同意
            <a href="javascript:;" @click="openAgreement('user')">《用户服务协议》</a>
            和
            <a href="javascript:;" @click="openAgreement('privacy')">《隐私政策》</a>
          </span>
        </div>
      </div>

      <!-- 第二步：注册成功后展示下载 -->
      <div class="card" v-else>
        <div class="success">
          <i class="el-icon-circle-check success-icon"></i>
          <div class="success-text">登录成功，欢迎加入{{ cfg.appName }}</div>
          <div class="success-sub">请下载 APP，开启你的脱单之旅</div>
        </div>

        <!-- 原链接下载：安卓 / 苹果 -->
        <div class="dl-group">
          <div class="dl-group-title">原链接下载</div>
          <div class="dl-btns">
            <button class="dl-btn android" @click="downloadApk">
              <i class="el-icon-download"></i> 安卓下载
            </button>
            <button class="dl-btn ios" @click="downloadIpa">
              <i class="el-icon-download"></i> 苹果下载
            </button>
          </div>
        </div>

        <!-- 应用市场下载：按机型引导 -->
        <div class="dl-group">
          <div class="dl-group-title">应用市场下载</div>
          <button class="dl-btn market" @click="downloadMarket">
            <i class="el-icon-menu"></i> {{ marketBtnText }}
          </button>
          <div class="dl-hint">{{ marketHint }}</div>
        </div>
      </div>

      <div class="footer">
        <div>© {{ year }} {{ cfg.companyShort }} 版权所有</div>
        <div>
          <a class="beian" :href="cfg.beianUrl" target="_blank" rel="noopener noreferrer">{{ cfg.icpNo }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    httpRequest
  } from '@/utils/app'
  import config from '@/utils/config'

  export default {
    name: 'Download',
    data() {
      return {
        cfg: config.appDownload,
        shareCode: '',
        mobile: '',
        agreed: false,
        submitting: false,
        registered: false,
        isIOS: false,
        isAndroid: false,
        isWeixin: false
      }
    },
    computed: {
      marketBtnText() {
        if (this.isIOS) return '前往 App Store'
        if (this.isAndroid) return '前往安卓应用市场'
        return '前往应用市场'
      },
      marketHint() {
        if (this.isIOS) return '将为你跳转到 App Store 搜索下载'
        if (this.isAndroid) return '将为你跳转到手机自带应用市场下载'
        return '请根据手机系统选择对应应用市场'
      },
      year() {
        return new Date().getFullYear()
      }
    },
    created() {
      // 自动获取链接中的 share_code
      this.shareCode = (this.$route.query.share_code || '').toString().trim().toUpperCase()

      // 机型识别
      const ua = navigator.userAgent.toLowerCase()
      this.isIOS = /iphone|ipad|ipod/.test(ua)
      this.isAndroid = /android/.test(ua)
      this.isWeixin = /micromessenger/.test(ua)
    },
    methods: {
      submit() {
        if (this.submitting) return
        if (!/^1\d{10}$/.test(this.mobile)) {
          this.$message({
            type: 'warning',
            message: '请输入正确的手机号'
          })
          return
        }
        if (!this.agreed) {
          this.$message({
            type: 'warning',
            message: '请先阅读并同意用户服务协议和隐私政策'
          })
          return
        }
        this.submitting = true
        const params = {
          action: 'user_regist',
          mobile: this.mobile
        }
        if (this.shareCode) {
          params.share_code = this.shareCode
        }
        httpRequest(params, 'POST').then(response => {
          this.submitting = false
          if (response && response.error === false) {
            this.registered = true
          } else {
            this.$message({
              type: 'error',
              message: (response && response.msg) || '登录失败，请稍后重试'
            })
          }
        })
      },

      // 通用跳转：链接为空（未上架）时友好提示
      goto(url, tip) {
        if (!url) {
          this.$message({
            type: 'info',
            message: tip || '应用即将上架，敬请期待'
          })
          return
        }
        window.location.href = url
      },

      // 原链接下载：安卓 APK
      downloadApk() {
        this.goto(this.cfg.androidApkUrl, '安卓版即将上线，敬请期待')
      },

      // 原链接下载：苹果（优先直链，其次 App Store 详情页）
      downloadIpa() {
        this.goto(this.cfg.iosIpaUrl || this.cfg.iosAppStoreUrl, '苹果版即将上线，敬请期待')
      },

      // 应用市场下载：按机型引导
      downloadMarket() {
        if (this.isWeixin) {
          this.$message({
            type: 'info',
            message: '请在浏览器中打开后再跳转应用市场'
          })
          return
        }
        if (this.isIOS) {
          const url = this.cfg.iosAppStoreUrl ||
            (this.cfg.iosAppStoreId ? 'itms-apps://itunes.apple.com/app/id' + this.cfg.iosAppStoreId : '')
          this.goto(url, 'App Store 即将上线，敬请期待')
          return
        }
        if (this.isAndroid) {
          const url = this.cfg.androidPackage ?
            'market://details?id=' + this.cfg.androidPackage :
            this.cfg.androidMarketUrl
          this.goto(url, '安卓应用市场即将上线，敬请期待')
          return
        }
        this.goto(this.cfg.androidMarketUrl, '应用即将上架，敬请期待')
      },

      openAgreement(type) {
        // 协议详情由后端 pageset 提供，落地页仅做占位跳转提示
        this.$message({
          type: 'info',
          message: type === 'user' ? '用户服务协议详见 APP 内' : '隐私政策详见 APP 内'
        })
      }
    }
  }
</script>

<style scoped>
  .landing {
    min-height: 100vh;
    background: linear-gradient(160deg, #ff6a8e 0%, #ff8fab 35%, #ffd6e0 100%);
    display: flex;
    justify-content: center;
    padding: 24px 16px 40px;
    box-sizing: border-box;
  }

  .landing-inner {
    width: 100%;
    max-width: 420px;
  }

  .brand {
    text-align: center;
    color: #fff;
    margin-bottom: 20px;
  }

  .brand-logo {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 84px;
    height: 84px;
    border-radius: 22px;
    box-shadow: 0 8px 24px rgba(220, 35, 128, 0.28);
    background: #fff;
    color: #dc2380;
    font-size: 56px;
    line-height: 1;
  }

  .brand-name {
    font-size: 26px;
    font-weight: 700;
    margin-top: 12px;
    letter-spacing: 2px;
  }

  .brand-slogan {
    font-size: 13px;
    opacity: 0.92;
    margin-top: 6px;
  }

  .invite-tip {
    text-align: center;
    color: #fff;
    font-size: 13px;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 20px;
    padding: 7px 14px;
    margin: 0 auto 14px;
    width: fit-content;
  }

  .invite-tip b {
    letter-spacing: 2px;
  }

  .wx-tip {
    background: #fff7e6;
    color: #d46b08;
    font-size: 12px;
    line-height: 1.6;
    border-radius: 10px;
    padding: 10px 12px;
    margin-bottom: 14px;
  }

  .card {
    background: #fff;
    border-radius: 18px;
    padding: 24px 20px;
    box-shadow: 0 12px 32px rgba(220, 35, 128, 0.16);
  }

  .card-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    text-align: center;
    margin-bottom: 20px;
  }

  .phone-input {
    margin-bottom: 16px;
  }

  .submit-btn {
    width: 100%;
    background: #dc2380;
    border-color: #dc2380;
    border-radius: 24px;
    font-size: 16px;
    height: 46px;
  }

  .submit-btn:hover,
  .submit-btn:focus {
    background: #e83f95;
    border-color: #e83f95;
  }

  .agreement {
    display: flex;
    align-items: flex-start;
    margin-top: 16px;
    font-size: 12px;
    color: #888;
    line-height: 1.5;
  }

  .agreement-text a {
    color: #dc2380;
    text-decoration: none;
  }

  .success {
    text-align: center;
    margin-bottom: 22px;
  }

  .success-icon {
    font-size: 54px;
    color: #52c41a;
  }

  .success-text {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-top: 10px;
  }

  .success-sub {
    font-size: 13px;
    color: #999;
    margin-top: 6px;
  }

  .dl-group {
    margin-top: 20px;
  }

  .dl-group-title {
    font-size: 14px;
    color: #666;
    font-weight: 600;
    margin-bottom: 10px;
    border-left: 3px solid #dc2380;
    padding-left: 8px;
  }

  .dl-btns {
    display: flex;
    gap: 12px;
  }

  .dl-btn {
    flex: 1;
    border: none;
    border-radius: 12px;
    height: 48px;
    font-size: 15px;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .dl-btn.android {
    background: #3ddc84;
  }

  .dl-btn.ios {
    background: #333;
  }

  .dl-btn.market {
    width: 100%;
    background: linear-gradient(90deg, #ff6a8e, #dc2380);
  }

  .dl-hint {
    font-size: 12px;
    color: #aaa;
    margin-top: 8px;
    text-align: center;
  }

  .footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0 18px;
    text-align: center;
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;
    margin-top: 24px;
    line-height: 1.9;
  }

  .footer .beian,
  .footer .beian:visited {
    color: rgba(255, 255, 255, 0.85);
    text-decoration: none;
  }

  .footer .beian:hover {
    color: #fff;
  }

  /* PC 端：卡片加宽、字号与留白上调，并在视口内垂直居中，避开窄列贴顶的手机观感 */
  @media only screen and (min-width: 768px) {
    .landing {
      align-items: center;
      padding: 40px 24px;
    }

    .landing-inner {
      max-width: 520px;
    }

    .brand-logo {
      width: 96px;
      height: 96px;
      border-radius: 26px;
      font-size: 64px;
    }

    .brand-name {
      font-size: 30px;
    }

    .brand-slogan {
      font-size: 14px;
    }

    .card {
      padding: 32px 30px;
      border-radius: 22px;
    }

    .card-title {
      font-size: 20px;
    }

    .submit-btn {
      height: 50px;
    }

    .dl-btn {
      height: 52px;
    }
  }

  /* 小屏手机：压缩留白与字号，保证下载按钮不拥挤 */
  @media only screen and (max-width: 414px) {
    .landing {
      padding: 18px 12px 28px;
      /* 全面屏底部横条不遮挡页脚 */
      padding-bottom: calc(28px + env(safe-area-inset-bottom));
    }

    .brand {
      margin-bottom: 16px;
    }

    .brand-logo {
      width: 72px;
      height: 72px;
      border-radius: 18px;
      font-size: 48px;
    }

    .brand-name {
      font-size: 22px;
    }

    .card {
      padding: 20px 16px;
      border-radius: 16px;
    }

    .dl-btns {
      gap: 8px;
    }

    .dl-btn {
      font-size: 14px;
    }
  }

  /* 横屏矮窗口（手机转屏）：不强行占满一屏，改为顶部对齐自然滚动 */
  @media only screen and (max-height: 560px) {
    .landing {
      min-height: auto;
      align-items: flex-start;
      padding-top: 20px;
    }

    .brand {
      margin-bottom: 12px;
    }

    .brand-logo {
      width: 60px;
      height: 60px;
      font-size: 40px;
    }

    .success-icon {
      font-size: 40px;
    }

    .dl-group {
      margin-top: 14px;
    }
  }
</style>
